import { Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";

import "./App.css";
import HomePage from "./pages/HomePage";
import BooksAndReviews from "./pages/BooksAndReviews";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";
import Works from "./pages/Works";
import Ambassadors from "./pages/Ambassadors";
import UserProfile from "./pages/UserProfile";
import PersonalPeofile from "./pages/PersonalPeofile";
import PersonalSeller from "./pages/PersonalSeller";

import AccountNotification from "./pages/AccountNotification";
import PrivacyAccount from "./pages/PrivacyAccount";
import Settings from "./pages/Settings";
import HomePage2 from "./pages/HomePage2";
import BooksAndReview from "./pages/BooksAndReview";
import CreateMeetup from "./pages/CreateMeetup";
import GroupEvent from "./pages/GroupEvent";
import MeetupOrganizer from "./pages/MeetupOrganizer";
import Leading from "./pages/Leading";
import Reviews from "./pages/Reviews";
import DashBoardUser from "./pages/DashBoardUser";
import UserBooksAndReviews from "./pages/UserBooksAndReviews";
import AmbassProfile from "./pages/AmbassProfile";
import AmbassUserProfile from "./pages/AmbassUserProfile";
import GroupEventCreation from "./pages/GroupEventCreation";
import BooksGroupEventCreation from "./pages/BooksGroupEventCreation";
import BooksDetails from "./pages/image/BooksDetails";
import ChatBox from "./pages/ChatBox";
import Help from "./pages/Help";
import SuggestiveBooks from "./pages/SuggestiveBooks";
import ChatBox2 from "./pages/ChatBox2";
import LoyalityProgramme from "./pages/LoyalityProgramme";
import BooksAndReviews2 from "./pages/BooksAndReviews2";
import AccountNotification2 from "./pages/AccountNotification2";
import ForgotPasssword from "./pages/Auth/ForgotPasssword";
import Pagenotfound from "./pages/Pagenotfound";
import BookList from "./pages/BookList";
import BookDetailPage from "./pages/BookDetailPage";
// import AboutUsBook from './pages/AboutUsBook';

import { Toaster } from "react-hot-toast";
import MeetupOrganizerOpen from "./pages/MeetupOrganizerOpen";
import SilentReading from "./pages/image/SilentReading";
import SilenrReadingAbout from "./pages/SilentReadingAbout";
import AllDataUser from "./pages/admin/AllDataUser";
import NotificationPage from "./pages/NotificationPage";
import AmbassadorRequest from "./pages/admin/AmbassadorRequest";
// import Chatnew from './pages/Chatnew';
import { io } from "socket.io-client";
import { useContext, useEffect, useState } from "react";
import SocketContext from "./context/SocketContext";
import Chat from "./pages/Chat";
import {
  NotificationContext,
  NotificationProvider,
} from "./context/NotificationContext";
import ChatProvider from "./context/ChatProvider";
import { ChatState } from "./context/ChatProvider";

import Chatt from "./pages/chat/chat";
import AdminPanel from "./pages/AdminPanel";
import StoreManagement from "./pages/admin/StoreManagement";
import SuggestiveBookAdd from "./pages/admin/SuggestiveBookAdd";
import UserView from "./pages/UserView";
import AdminMenuManagerLanguage from "./pages/admin/LangaugeManagement";
import AdminBookClubsManager from "./pages/admin/ManageClubMembers";
import GetReviews from "./pages/admin/GetReviews";
import SuggestiveBookPage from "./pages/admin/SuggestiveBookPage";
import AccountPerfernce from "./pages/admin/AccountPerfernce";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminChangePassword from "./pages/admin/AdminChangePassword";
import GoogleAnalytics from "./pages/admin/GoogleAnalytics";
import VerifyEmailChange from "./pages/VerifyEmailChange";
import VerifyPasswordChange from "./pages/VerifyPasswordChange";
import { BASE_URL, BASE_URL_Socket } from "./config/BaseUrls";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
import LeadingNew from "./pages/LeadingNew";
import axios from "axios";
import { trackPageView } from "./utils/googleAnalytics";
import PWAInstallPrompt from "./components/PWAInstallPrompt";

function App() {
  const { notifications, setNotifications } = useContext(NotificationContext);

  const userData = JSON.parse(localStorage.getItem("auth"));
  const { user, setShowLoginM } = ChatState();
  const [userId, setUserId] = useState(null); // User ID (null if not logged in)
  const [socket, setSocket] = useState(null); // Socket instance

  // Simulate login/logout
  const handleLogin = (userId) => {
    setUserId(userId);
  };

  const handleLogout = () => {
    setUserId(null);
  };

  // Initialize Socket.IO connection only if the user is logged in
  useEffect(() => {
    let fetUser = user?._id ? user : userData?.user;

    if (fetUser?._id) {
      const newSocket = io(BASE_URL_Socket, {
        path: "/socket.io",
        transports: ["websocket", "polling"],
        upgrade: true,
      });

      // Register user
      newSocket.emit("setup", fetUser);

      // Listen for notifications
      newSocket.on("notification", (notification) => {
        console.log("new notification recieved")
        // Add new notification at the beginning (newest first) and maintain order
        setNotifications((prev) => {
          const updated = [notification, ...prev];
          // Sort by createdAt to ensure newest first (in case timestamps are inconsistent)
          return updated.sort((a, b) => {
            const dateA = new Date(a.createdAt || a.timestamp || 0);
            const dateB = new Date(b.createdAt || b.timestamp || 0);
            return dateB - dateA; // Newest first
          });
        });
        const audio = new Audio(
          require("./pages/image/mixkit-positive-notification-951.wav")
        );
        audio.play().catch((e) => console.error("Audio error:", e));
      });

      // Store the socket instance
      setSocket(newSocket);

      // Cleanup on component unmount or logout
      return () => {
        newSocket.disconnect();
        setSocket(null);
      };
    } else {
      // If the user logs out, disconnect the socket
      if (socket) {
        socket.disconnect();
        setSocket(null);
      }
    }
  }, [user]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [responseData, setResponseData] = useState(null);

  // Track page views for Google Analytics (initialized in index.html)
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Ofellio | Discover reading events & more</title>
        </Helmet>
        <SocketContext.Provider value={socket}>
          <Routes>
            <Route path="/home" element={<HomePage />} />
            <Route path="/leading" element={<LeadingNew />} />
            <Route
              path="/chat/:ambassadorId"
              element={<Chat userId={userId} />}
            />
            <Route path="/chatChak/:id" element={<Chatt />} />
            <Route path="/chatChak" element={<Chatt />} />
            <Route path="/" element={<HomePage2 />} />
            <Route path="/reset/:token" element={<HomePage2 />} />
            <Route path="/booksandreviews2" element={<BooksAndReviews />} />
            <Route path="/booksandreviews" element={<BooksAndReviews2 />} />
            <Route path="/booksandreview" element={<BooksAndReview />} />
            {/* <Route path="/booksandreview/:title" element={<BooksAndReview />} />
              <Route path="/booksandreview/:city" element={<BooksAndReview />} /> */}
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/howitworks" element={<Works />} />
            <Route path="/ambassador" element={<Ambassadors />} />
            {/* <Route path='/dashboard' element={<UserProfile />} /> */}
            <Route path="/profile" element={<PersonalPeofile />} />
            <Route path="/personal-seller" element={<PersonalSeller />} />
            <Route
              path="/accountnotification"
              element={<AccountNotification />}
            />
            <Route
              path="/accountnotification/accountnotifications"
              element={<AccountNotification2 />}
            />
            {/* <Route path="/privacyaccount" element={<PrivacyAccount />} /> */}
            {/* <Route path='/settings' element={<Settings />} /> */}
            <Route path="/settings" element={<AmbassUserProfile />} />
            <Route path="/createmeetup" element={<CreateMeetup />} />
            <Route path="/booksandreview/groupevent" element={<GroupEvent />} />
            <Route path="/groupevent" element={<GroupEvent />} />
            {/* <Route path='/aboutusbook' element={<AboutUsBook />} /> */}
            <Route path="/meetorganizer" element={<MeetupOrganizer />} />
            {/* <Route path='/meetorganizeropen' element={<MeetupOrganizerOpen />} /> */}
            <Route path="/leading-new" element={<Leading />} />
            <Route path="/loyalty" element={<LoyalityProgramme />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/dashboarduser" element={<DashBoardUser />} />
            <Route
              path="/booksandreviewsuser"
              element={<UserBooksAndReviews />}
            />
            <Route
              path="/ambassadoruserprofile"
              element={<AmbassUserProfile />}
            />
            <Route path="/ambassadorprofile" element={<AmbassUserProfile />} />
            {/* <Route path='/groupeventcreation' element={<GroupEventCreation />} /> */}
            {/* <Route path='/booksgroupeventcreation' element={<BooksGroupEventCreation />} /> */}
            <Route path="/booksdetails" element={<BooksDetails />} />
            <Route path="/createmeetup/:id" element={<CreateMeetup />} />
            <Route path="/booksdetails/:id" element={<BooksDetails />} />
            <Route path="/silentreading" element={<SilentReading />} />
            <Route path="/silentreading/:id" element={<SilentReading />} />
            <Route path="/leading/silentreading" element={<SilentReading />} />
            <Route path="/loyalty/silentreading" element={<SilentReading />} />
            <Route
              path="/silentreadingabout"
              element={<SilenrReadingAbout />}
            />
            <Route path="/chatbox" element={<ChatBox />} />
            <Route path="/chatbox2" element={<ChatBox2 />} />
            <Route path="/help" element={<Help />} />
            <Route path="/suggestivebooks" element={<SuggestiveBooks />} />
            <Route path="/forgot-password" element={<ForgotPasssword />} />
            <Route path="*" element={<Pagenotfound />} />
            <Route path="/booklist" element={<BookList />} />{" "}
            {/* // not a show page clint// */}
            <Route path="/book/:id" element={<BookDetailPage />} />
            {/* admin */}
            <Route
              path="/admin/ambassador"
              element={
                <ProtectedAdminRoute>
                  <AmbassadorRequest />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/ambassadors-list"
              element={
                <ProtectedAdminRoute>
                  <AmbassadorRequest />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/alldata"
              element={
                <ProtectedAdminRoute>
                  <AllDataUser />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/storemanage"
              element={
                <ProtectedAdminRoute>
                  <StoreManagement />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/admin-users"
              element={
                <ProtectedAdminRoute>
                  <AdminUsers />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/google-api"
              element={
                <ProtectedAdminRoute>
                  <GoogleAnalytics />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/change-password"
              element={
                <ProtectedAdminRoute>
                  <AdminChangePassword />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/suggestivebookadd"
              element={
                <ProtectedAdminRoute>
                  <SuggestiveBookAdd />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/ofelliossuggestive"
              element={
                <ProtectedAdminRoute>
                  <SuggestiveBookPage />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/allreviews"
              element={
                <ProtectedAdminRoute>
                  <GetReviews />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/getnewsletter"
              element={
                <ProtectedAdminRoute>
                  <AccountPerfernce />
                </ProtectedAdminRoute>
              }
            />
            <Route path="/userview" element={<UserView />} />
            <Route
              path="/admin/language"
              element={
                <ProtectedAdminRoute>
                  <AdminMenuManagerLanguage />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/age-ranges"
              element={
                <ProtectedAdminRoute>
                  <AdminMenuManagerLanguage />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/languages"
              element={
                <ProtectedAdminRoute>
                  <AdminMenuManagerLanguage />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/club-management"
              element={
                <ProtectedAdminRoute>
                  <AdminBookClubsManager />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/book-duos"
              element={
                <ProtectedAdminRoute>
                  <AdminBookClubsManager />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/silent-readings"
              element={
                <ProtectedAdminRoute>
                  <AdminBookClubsManager />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/events"
              element={
                <ProtectedAdminRoute>
                  <AdminBookClubsManager />
                </ProtectedAdminRoute>
              }
            />
            <Route path="/notification" element={<NotificationPage />} />
            <Route
              path="/admindashboard"
              element={
                <ProtectedAdminRoute>
                  <AdminPanel />
                </ProtectedAdminRoute>
              }
            />
            {/* <Route path="/chatnew" element={<Chatnew />} /> */}
            <Route
              path="/verify-email-change"
              element={<VerifyEmailChange />}
            />
            <Route
              path="/verify-password-change"
              element={<VerifyPasswordChange />}
            />
          </Routes>
        </SocketContext.Provider>
      </HelmetProvider>
      <Toaster />
      <PWAInstallPrompt />
    </>
  );
}

export default App;
